export let AppName;
(function (AppName) {
  AppName["Crm"] = "CrmSignup";
  AppName["FbCrm"] = "FbCrmSignup";
  AppName["Marketing"] = "MarketingSignup";
  AppName["Integrations"] = "IntegrationsSignup";
  AppName["Sales"] = "SalesSignup";
  AppName["Service"] = "ServiceSignup";
  AppName["ClassroomTraining"] = "ClassroomTrainingSignup";
  AppName["AssetProvider"] = "AssetProvider";
  AppName["Purchase"] = "PurchaseSignup";
  AppName["Academy"] = "AcademySignup";
  AppName["CmsDevelopers"] = "DeveloperContentHubSignup";
  AppName["HubspotForStartups"] = "HubSpotForStartupsSignup";
  AppName["DirectoryListing"] = "DirectoryUserSignup";
  AppName["HubSpotPartners"] = "HubSpotPartnersSignup";
  AppName["Wordpress"] = "WordpressSignup";
  AppName["Trial"] = "TrialSignup";
  AppName["CmsFree"] = "CmsFreeSignup";
  AppName["Microapp"] = "MicroappSignup";
  AppName["Commerce"] = "CommerceSignup";
  AppName["AeoStandalone"] = "AeoStandaloneSignup";
})(AppName || (AppName = {}));